import * as React from 'react';
import { Space, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import MLModel from '../../../ml_models/models/MLModel';
import { PromptTemplate } from '../../../prompt_templates/types';
import { ApplicationDefinitionBase } from '../../../iota_applications/types/ApplicationDefinition';
import { Script } from '../../../script_management/types';
import { PipelineStep, PipelineStepFieldValue, PipelineStepType } from './CustomBlock';
import { PipelineStepCard } from './PipelineStepCard';

interface InterpretationBlockPipelineProps {
    pipeline: PipelineStep[];
    models: MLModel[];
    promptTemplates: PromptTemplate[];
    applicationDefinitions: ApplicationDefinitionBase[];
    scripts: Script[];
    isLoadingModels: boolean;
    isLoadingPrompts: boolean;
    isLoadingApplications: boolean;
    isLoadingScripts: boolean;
    disabled: boolean;
    onAddStep: () => void;
    onRemoveStep: (stepIndex: number) => void;
    onStepTypeChange: (stepIndex: number, newType: PipelineStepType) => void;
    onStepFieldChange: (stepIndex: number, field: string, value: PipelineStepFieldValue) => void;
    onMoveStep: (dragIndex: number, hoverIndex: number) => void;
}

const InterpretationBlockPipeline: React.FC<InterpretationBlockPipelineProps> = ({
    pipeline,
    models,
    promptTemplates,
    applicationDefinitions,
    scripts,
    isLoadingModels,
    isLoadingPrompts,
    isLoadingApplications,
    isLoadingScripts,
    disabled,
    onAddStep,
    onRemoveStep,
    onStepTypeChange,
    onStepFieldChange,
    onMoveStep
}) => {
    if (!pipeline) {
        return null;
    }
    return (
        <div className="interpretation-block-pipeline">
            <label className="custom-block-label">Pipeline Steps</label>
            <DndProvider backend={HTML5Backend}>
                <Space direction="vertical" style={{ width: '100%' }} size="small">
                    {pipeline.map((step, stepIndex) => (
                        <PipelineStepCard
                            key={stepIndex}
                            step={step}
                            stepIndex={stepIndex}
                            models={models}
                            promptTemplates={promptTemplates}
                            applicationDefinitions={applicationDefinitions}
                            scripts={scripts}
                            isLoadingModels={isLoadingModels}
                            isLoadingPrompts={isLoadingPrompts}
                            isLoadingApplications={isLoadingApplications}
                            isLoadingScripts={isLoadingScripts}
                            disabled={disabled}
                            onRemove={() => onRemoveStep(stepIndex)}
                            onTypeChange={newType => onStepTypeChange(stepIndex, newType)}
                            onFieldChange={(field, value) => onStepFieldChange(stepIndex, field, value)}
                            moveStep={onMoveStep}
                        />
                    ))}
                    <Button onClick={onAddStep} icon={<PlusOutlined />} disabled={disabled} size="small" block>
                        Add Pipeline Step
                    </Button>
                </Space>
            </DndProvider>
        </div>
    );
};

export default InterpretationBlockPipeline;
